import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import {  decodeEmoji } from '../../emoji-picker/emojiMap';
import { MessageElement } from '../../model';
 


@Component({
  selector: 'app-text-element',
  templateUrl: './text-element.component.html',
  styleUrls: ['./text-element.component.css']
})
export class TextElementComponent implements OnInit {
  @Input() text: string = "";
  contextList:Array<MessageElement>= [];
  constructor() { }

  ngOnInit(): void {
    this.contextList = decodeEmoji(this.text);
  }

}
